import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, startSignIn } from '../lib/auth';
import { getConfig } from '../lib/config';
import { theme } from '../theme';

export function LoginPage() {
  const [error, setError] = useState<string | null>(null);
  const { environment } = getConfig();

  useEffect(() => {
    if (isAuthenticated()) return;
    startSignIn().catch((err) => {
      setError((err as Error).message);
    });
  }, []);

  if (isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <img
          src="/tradebid-logo-white.svg"
          alt="TradeBid"
          width={200}
          height={30}
          style={styles.logo}
        />
        <h1 style={styles.title}>OBD Reader</h1>
        <p style={styles.body}>Signing you in via TradeBid staff SSO…</p>
        {environment === 'local' && (
          <p style={styles.body}>
            (Local dev mode: SSO bypassed — you should already be authenticated.)
          </p>
        )}
        {error && <p style={styles.error}>Sign-in failed: {error}</p>}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.surface.page,
  },
  card: {
    width: 420,
    padding: '40px 32px',
    background: theme.surface.header,
    border: `1px solid ${theme.surface.border}`,
    borderTop: `3px solid ${theme.brand.primary}`,
    borderRadius: theme.radius.xl,
    textAlign: 'center',
  },
  logo: {
    height: 30,
    width: 'auto',
    marginBottom: 24,
    display: 'inline-block',
  },
  title: {
    margin: 0,
    marginBottom: 12,
    fontSize: 24,
    fontWeight: 600,
    color: theme.text.primary,
  },
  body: { color: theme.text.secondary, fontSize: 14, margin: '4px 0' },
  error: { color: theme.status.error, fontSize: 13, marginTop: 12 },
};
